// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentContainer_k0q0o {
  display: flex;
  flex-direction: column;
  padding: 10px 23px;
  max-height: 55vh;
  overflow-y: auto;

  .content_F5oiX {
    background-color: var(--white-background);
    box-sizing: border-box;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    p,
    h2 {
      margin: 0;
    }
    .btnContainer_btdJK {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: center;
      width: 100%;
    }
    .iconContainer_YTRJ2 {
      width: 30%;
      margin: 0 auto;
      height: 30%;
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewUserInformation/NewUserInformation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT;;MAEE,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,uBAAuB;MACvB,WAAW;IACb;IACA;MACE,UAAU;MACV,cAAc;MACd,WAAW;MACX;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;AACF","sourcesContent":[".contentContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 23px;\n  max-height: 55vh;\n  overflow-y: auto;\n\n  .content {\n    background-color: var(--white-background);\n    box-sizing: border-box;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    p,\n    h2 {\n      margin: 0;\n    }\n    .btnContainer {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      justify-content: center;\n      width: 100%;\n    }\n    .iconContainer {\n      width: 30%;\n      margin: 0 auto;\n      height: 30%;\n      svg {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `contentContainer_k0q0o`,
	"content": `content_F5oiX`,
	"btnContainer": `btnContainer_btdJK`,
	"iconContainer": `iconContainer_YTRJ2`
};
export default ___CSS_LOADER_EXPORT___;
